<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w1200 mauto mt50 mb50 bgfff overflow">
                <div class="bgf6 w65p disinblock floatl pl30 pr30 baee">
                    <div class="pt20 pb20 textc  border2 mauto">
                        <p class="fs20 c333 disinblock w80p"> {{news.Title}} </p>
                        <p class="fs14 c666 pt10 pb10">
                            <span class="fs14 c666 mr10"> 发布时间 : {{news.Time | formatDate}} </span>
                            <span class="fs14 c666 ml10"> 作者 : {{news.Author}} </span>
                        </p>
                    </div>
                    <div class="pt15 pb15" v-html="news.Detail">
                    </div>
                </div>
                <Registration :Area_id="Area_idX"></Registration>
            </div>
        </div>
        <Footer></Footer>  
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Registration from '@/components/Registration'
    import $axios from "axios";
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                news: {
                    Detail: '',
                    Title: '',
                    Author: '',
                    Time: '',
                },
                Area_idX: ''
            };
        },
        components: {
            Header,
            Footer,
            Registration
        },
        filters: {
            formatDate(value) {
                var d = new Date(parseInt(value) * 1000);
                return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' +
                    (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
            }
        },
        methods: {
            getDetail() {
                let that = this;
                that.news = that.$store.state.newsDetail;
                that.Area_idX = that.$route.query.cityid;
                for (let i = 0; i < that.news.length; i++) {
                    if (that.news[i].id == that.$route.query.news_id) {
                        that.news.Detail = that.news[i].content;
                        that.news.Title = that.news[i].title;
                        that.news.Author = that.news[i].author;
                        that.news.Time = that.news[i].update_time;
                    }

                }
            },
        },
        created() {
            this.getDetail();
            this.cityName = this.$store.state.cityName;
        },

        computed: {

        },
    }
</script>
<style scoped>

</style>